const model = {
  annotator: '',
  candidateId: '',
  candidateJobId: '',
  candidateName: '',
  candidateUrl: '',
  engagementId: '',
  engagementStage: '',
  engagementStatus: '',
  engagementUrl: '',
  employerName: '',
  jobId: '',
  jobName: '',
  jobRoles: '',
  jobUrl: '',
  matchDecision: '',
  matchingUrl: '',
  probScore: '',
  reviewed: '',
  shouldNotTag: '',
  shouldTag: '',
  source: '',
  whyNeedToReadCV: '',
  whyNoCategories: [],
  whyNoDetails: '',
  whyNoPrivateNote: '',
  whyYesCategories: [],
  whyYesDetails: '',
  whyYesPrivateNote: ''
};

const mapDisagreement = item => {
  const engagement = { modelName: "engagement", ...model };
  return { ...engagement, ...Object(item) }
};

const mapDisagreements = data => {
  return (data || []).map(item => {
    const disagreement = mapDisagreement(item);
    return disagreement;
  });
};

const EngagementDisagreement = {
  model,
  mapDisagreement,
  mapDisagreements,
};

export {
  EngagementDisagreement as default,
  mapDisagreement,
  mapDisagreements,
  model
};

